export const API_KEYS = {
    IMAGE_URL: 'imageUrl',
    NAME: 'name',
    DESCRIPTION: 'description'
}